/** * app菜单管理 */
<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <!-- 搜索筛选 -->
      <el-form :inline="true" class="user-search" @submit.native.prevent>
        <el-form-item label="模块名称：">
          <el-input size="small" v-model="formInline.menuName" placeholder="请输入模块名称" @keyup.enter.native="search">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新增</el-button>
          <my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @handleOperation="handleRowClick" :rowKey="'keyId'"
        :tree-props="{ children: 'subList', hasChildren: 'hasChildren' }">
        <el-table-column slot="isShow" align="center" prop="isShow" label="是否显示">
          <template slot-scope="scope">
            <span @click.stop>
              <el-switch v-model="scope.row.isShow" active-color="#13ce66" inactive-color=""
                @change="editType(scope.row)">
              </el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column slot="color" align="center" prop="color" label="颜色" width="80">
          <template slot-scope="scope">
            <div :style="{
              width: '60px',
              height: '20px',
              backgroundColor: scope.row.color,
            }"></div>
          </template>
        </el-table-column>
        <el-table-column slot="operate" align="center" label="操作" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.subList" size="mini" type="primary" icon="el-icon-plus"
              @click="handleAdd(scope.row)">新增</el-button>
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      <!-- 编辑界面 -->
      <el-drawer :title="title" :visible.sync="editFormVisible" @close="closeDialog" :size="600"
        :wrapperClosable="false" :modal="false" :destroy-on-close="true" class="margin_top_40">
        <el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="模块名称" prop="menuName">
            <el-input size="small" class="input_200px" v-model="editForm.menuName" auto-complete="off"
              placeholder="请输入模块名称">
            </el-input>
          </el-form-item>
          <el-form-item label="模块地址" prop="menuUrl">
            <el-input size="small" class="input_200px" v-model="editForm.menuUrl" auto-complete="off"
              placeholder="请输入模块地址">
            </el-input>
          </el-form-item>
          <el-form-item label="模块图标" prop="icon">
            <el-input size="small" class="input_200px" v-model="editForm.icon" auto-complete="off"
              placeholder="请输入模块图标"></el-input>
          </el-form-item>
          <el-form-item label="关联角色" prop="roles">
            <el-select class="input_200px" v-model="editForm.roles" multiple filterable placeholder="请选择" size="small">
              <el-option v-for="item in roleList" :key="item.keyId" :label="item.value" :value="item.keyId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示顺序" prop="order">
            <el-input size="small" class="input_200px" v-model.number="editForm.order" auto-complete="off"
              placeholder="请输入显示顺序"></el-input>
          </el-form-item>
          <el-form-item label="颜色" prop="color">
            <el-color-picker v-model="editForm.color"></el-color-picker>
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button size="small" icon="el-icon-check" :loading="saveloading" class="title"
            @click="submitForm('editForm')">
            保存
          </el-button>
          <el-button size="small" icon="el-icon-delete" type="danger" :loading="saveloading" class="title"
            @click="deleteMenu(editForm)">
            删除
          </el-button>
        </div>
      </el-drawer>
      
      <!-- 按钮 -->
      <editBtn ref="editBtn"></editBtn>
    </topTab>
  </div>
</template>

<script>
import {
  GetAppMenuList,
  SaveAppMenu,
  DelAppMenu,
  GetAppMenuDetail,
  SetAppMenuIsShow,
} from "../../../api/systemApi.js";
import { GetRoleDropList } from "../../../api/userApi.js";
import editBtn from './editBtn.vue';
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "菜单配置列表",
        },
      ],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      saveloading: false,
      pageShow: true,
      listData: [],
      columnsData: [], //显示列
      //所有列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "60",
          isKeep: true,
        },
        {
          prop: "menuName",
          label: "模块名称",
          align: "center",
          isKeep: true,
        },
        {
          prop: "menuUrl",
          label: "模块地址",
          align: "center",
          minWidth: "260",
        },
        {
          prop: "icon",
          label: "模块图标",
          align: "center",
        },
        {
          slot: "isShow",
          label: "是否显示",
          align: "center",
        },
        {
          prop: "order",
          label: "显示顺序",
          align: "center",
        },
        {
          slot: "color",
          label: "颜色",
          align: "center",
          width: "80",
        },
        {
          prop: "roles",
          label: "关联角色",
          align: "center",
        },
        {
          slot: "operate",
          label: "操作",
          width: "160",
        },
      ],
      editForm: {
        keyId: "",
        menuName: "",
        menuUrl: "",
        icon: "",
        order: "",
        isShow: true,
        roles: "",
        parentKeyId: "",
        color: "",
      },
      formInline: {
        pageIndex: 1,
        pageSize: 15,
        menuName: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10,
      },
      title: "新增",
      rules: {},
      roleList: [],
    };
  },
  // 注册组件
  components: {
    editBtn,
  },

  created() {
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.getRoleDropListData();
  },

  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 顶部tab页面切换
    changePages(tab) { },

    handleEdit(row) {
      this.editForm.parentKeyId = "";
      if (row) {
        this.title = "编辑";
        this.getAppMenuDetail(row.keyId);
        this.editForm.parentKeyId = row.parentKeyId;
      } else {
        this.title = "新增";
        this.editForm = this.$options.data.call(this).editForm;
        this.editFormVisible = true;
      }
    },
    // 新增子菜单
    handleAdd(row) {
      this.title = "新增";
      this.editForm = this.$options.data.call(this).editForm;
      this.editFormVisible = true;
      this.editForm.parentKeyId = row.keyId;
    },

    // 单击行数据
    handleRowClick(row) {
      this.handleEdit(row);
    },

    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },

    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },

    // 删除
    deleteMenu(row) {
      this.$confirm("确定要删除<" + this.editForm.menuName + ">吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delAppMenuData(row.keyId);
        })
        .catch((err) => { });
    },

    // 提交
    submitForm() {
      this.SaveAppMenuData();
    },

    // 是否展示
    editType(row) {
      let params = {
        keyId: row.keyId,
        isShow: row.isShow,
      };
      this.setAppMenuIsShow(params);
    },

    // 获取列表
    getListData() {
      this.loading = true;
      this.listData = [];
      GetAppMenuList(this.formInline)
        .then((res) => {
          if (res.code === 1) {
            this.listData = res.data;
            this.loading = false;
            this.pageparm.currentPage = this.formInline.pageIndex;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 获取角色列表填充下拉框
    getRoleDropListData() {
      GetRoleDropList()
        .then((res) => {
          if (res.code === 1) {
            this.roleList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 删除APP菜单信息
    delAppMenuData(keyId) {
      let params = {
        keyId: keyId,
      };
      DelAppMenu(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "删除成功！",
            });
            this.closeDialog();
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 设置APP菜单是否显示和隐藏
    setAppMenuIsShow(params) {
      SetAppMenuIsShow(params)
        .then((res) => {
          if (res.code === 1) {
            this.formInline.pageIndex = 1;
            this.getListData();
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 获取APP菜单详情
    getAppMenuDetail(keyId) {
      let params = {
        keyId: keyId,
      };
      GetAppMenuDetail(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data.roles != null) {
              if (res.data.roles.indexOf(",") != -1) {
                let temp = res.data.roles.split(",");
                res.data.roles = temp;
              } else {
                let temp = [];
                temp.push(res.data.roles);
                res.data.roles = temp;
              }
            }

            this.editForm = res.data;
            this.editFormVisible = true;
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 保存
    SaveAppMenuData() {
      this.saveloading = true;
      this.editForm.roles = this.editForm.roles.toString();
      SaveAppMenu(this.editForm)
        .then((res) => {
          this.saveloading = false;
          if (res.code === 1) {
            this.editFormVisible = false;
            this.formInline.pageIndex = 1;
            this.getListData();
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.saveloading = false;
          this.$message.error("操作失败，请稍后再试！");
        });
    },

    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData(this.formInline);
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.search();
    },
  },
};
</script>

<style scoped></style>